import { Component } from '@theme/component';
import { swapPanels } from '@theme/tab-panels';

class SupportGuidesComponent extends Component {
  #triggers = [];
  #panels = [];
  #activeGroup = '';

  connectedCallback() {
    super.connectedCallback();

    this.#triggers = Array.from(this.querySelectorAll('[data-sgd-trigger]'));
    this.#panels = Array.from(this.querySelectorAll('[data-sgd-panel]'));
    this.#activeGroup = this.dataset.sgdInitial || this.#triggers[0]?.dataset.sgdGroup || '';

    if (!this.#triggers.length || !this.#panels.length) return;

    for (const trigger of this.#triggers) {
      trigger.addEventListener('click', this.#handleTriggerClick);
    }

    this.#syncState();
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    for (const trigger of this.#triggers) {
      trigger.removeEventListener('click', this.#handleTriggerClick);
    }
  }

  #handleTriggerClick = (event) => {
    const trigger = event.currentTarget;
    if (!(trigger instanceof HTMLElement)) return;

    const nextGroup = trigger.dataset.sgdGroup;
    if (!nextGroup || nextGroup === this.#activeGroup) return;

    this.#activeGroup = nextGroup;
    this.#syncState();
  };

  #syncState() {
    for (const trigger of this.#triggers) {
      const isActive = trigger.dataset.sgdGroup === this.#activeGroup;
      trigger.classList.toggle('is-active', isActive);
      trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
      trigger.setAttribute('tabindex', isActive ? '0' : '-1');
    }

    let activePanel = null;
    let previousVisible = null;

    for (const panel of this.#panels) {
      const isActive = panel.dataset.sgdGroup === this.#activeGroup;

      if (isActive) {
        activePanel = panel;
      } else if (!panel.hidden) {
        previousVisible = panel;
      }
    }

    if (!activePanel) return;

    if (activePanel.dataset.sgdMounted !== 'true') {
      this.#mountPanelTemplate(activePanel);
    }

    swapPanels({ container: this, oldPanel: previousVisible, newPanel: activePanel });
  }

  #mountPanelTemplate(panel) {
    const template = panel.querySelector('[data-sgd-template]');
    if (!template) {
      panel.dataset.sgdMounted = 'true';
      return;
    }

    panel.appendChild(template.content.cloneNode(true));
    template.remove();
    panel.dataset.sgdMounted = 'true';
  }
}

if (!customElements.get('support-guides-component')) {
  customElements.define('support-guides-component', SupportGuidesComponent);
}
